import { CSSProperties, FC, ReactNode } from 'react'
import { Tooltip } from 'antd'
import cn from './index.module.css'
import classNames from 'classnames'

interface ITooltipWrapper {
  title: ReactNode
  children: ReactNode
  className?: string
  overlayClassName?: string
  style?: CSSProperties
  placement?:
    | 'left'
    | 'right'
    | 'bottom'
    | 'top'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom'
}

const TooltipWrapper: FC<ITooltipWrapper> = ({
  title,
  children,
  className,
  overlayClassName,
  style,
  placement
}) => {
  return (
    <Tooltip
      style={style}
      className={className}
      title={title}
      overlayClassName={classNames(cn.tooltip, overlayClassName)}
      placement={placement}
    >
      <div></div>
      {children}
    </Tooltip>
  )
}

export default TooltipWrapper
